<template>
<div style="margin-top: 200px">
  <div id="tables">
    <div class="tables-1">
      <div class="container">
        <div class="row">
          <div class="col-md-6 ml-auto mr-auto text-center">
            <h2 class="title mb-4">Price estimator</h2>
            <div class="section-space">
              <p>We offer dynamic pricing, ensuring you only pay for the features you utilize and the extent of your usage.
                You have the flexibility to cancel at any time.</p>
              <p>Use the table below to estimate your monthly cost.</p>
            </div>
          </div>
        </div>
        <div class="row d-sm-block d-none">
          <div class="col-md-12 mx-auto">
            <div>
              <div class="card card-plain">
                <div class="card-body">
                  <div class="table-responsive" style="overflow-x: hidden">
                    <table class="table table-pricing">
                      <thead class="text-primary">
                      <tr>
                        <th>
                          <h3 class="mb-0">Feature</h3>
                        </th>
                        <th>
                          <h4> Minimum price</h4>
                        </th>
                        <th>
                          <h4> Price per unit</h4>
                        </th>
                        <th>
                          <h4> Enabled</h4>
                        </th>
                        <th>
                          <h4> Estimated usage</h4>
                        </th>
                        <th>
                          <h4> Total</h4>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>
                          Bookings
                        </td>
                        <td>
                          ${{ features.bookings.minimum }}
                        </td>
                        <td>
                          ${{ features.bookings.price }}/booking
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.bookings)"
                                     v-model="features.bookings.enabled"  />
                        </td>
                        <td>
                          <el-input-number v-on:change="updatePricing(features.bookings)" :disabled="!features.bookings.enabled"
                                           size="small" v-model="features.bookings.quantity" :min="1"  />
                          <span class="ml-2"> bookings</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.bookings.total}}</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Game management
                        </td>
                        <td>
                          ${{ features.game_management.minimum }}
                        </td>
                        <td>
                          ${{ features.game_management.price }}/game
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.game_management)"
                                     v-model="features.game_management.enabled"  />
                        </td>
                        <td>
                          <el-input-number :disabled="!features.game_management.enabled"
                                           v-on:change="updatePricing(features.game_management)"
                                           size="small" v-model="features.game_management.quantity" :min="1"  />
                          <span class="ml-2"> games</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.game_management.total}}</h4>
                            </div>
                          </div>
                        </td>

                      </tr>
                      <tr>
                        <td>
                          Photos
                        </td>
                        <td>
                          ${{ features.photos.minimum }}
                        </td>
                        <td>
                          ${{ features.photos.price }}/photo
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.photos)"
                                     v-model="features.photos.enabled"  />
                        </td>
                        <td>
                          <el-input-number :disabled="!features.photos.enabled" size="small" v-on:change="updatePricing(features.photos)"
                                           v-model="features.photos.quantity" :min="1"  />
                          <span class="ml-2"> photos</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.photos.total}}</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Waivers
                        </td>
                        <td>
                          ${{ features.waivers.minimum }}
                        </td>
                        <td>
                          ${{ features.waivers.price }}/waiver <br>
                          <span style="font-size: x-small"> Currently free when bundled with Bookings, Photos, or Game Management</span>
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.waivers)"
                                     v-model="features.waivers.enabled"  />
                        </td>
                        <td>
                          <el-input-number :disabled="!features.waivers.enabled"
                                           v-on:change="calculateFreeTotal(features.waivers)" size="small" v-model="features.waivers.quantity" :min="1"  />
                          <span class="ml-2"> waivers</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.waivers.total}}</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Checklists
                        </td>
                        <td>
                          ${{ features.checklists.minimum }}
                        </td>
                        <td>
                          ${{ features.checklists.price }}/checklist <br>
                          <span style="font-size: x-small"> Currently free when bundled with Bookings, Photos, or Game Management</span>
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.checklists)"
                                     v-model="features.checklists.enabled"  />
                        </td>
                        <td>
                          <el-input-number :disabled="!features.checklists.enabled"
                                           v-on:change="calculateFreeTotal(features.checklists)" size="small" v-model="features.checklists.quantity" :min="1"  />
                          <span class="ml-2"> checklists</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.checklists.total}}</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Surveys
                        </td>
                        <td>
                          ${{ features.surveys.minimum }}
                        </td>
                        <td>
                          ${{ features.surveys.price }}/survey <br>
                          <span style="font-size: x-small"> Currently free when bundled with Bookings, Photos, or Game Management</span>
                        </td>
                        <td>
                          <el-switch active-color="#e14eca" v-on:change="updatePricing(features.surveys)"
                                     v-model="features.surveys.enabled"  />
                        </td>
                        <td>
                          <el-input-number :disabled="!features.surveys.enabled" v-on:change="calculateFreeTotal(features.surveys)" size="small" v-model="features.surveys.quantity" :min="1"  />
                          <span class="ml-2"> surveys</span>
                        </td>
                        <td>
                          <div class="row">
                            <div class="col text-right">
                              <h4>${{features.surveys.total}}</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col text-right">
                        <h3>Estimated monthly total: ${{getTotalEstimate()}}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-sm-none d-block">
          <div class="col-md-12 mx-auto">
            <div>
              <div class="card card-plain">
                <div class="card-body">
                  <div class="table-responsive" style="overflow-x: hidden">
                    <table class="table table-pricing">
                      <tbody>
                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Bookings</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.bookings)"
                                         v-model="features.bookings.enabled"  />
                            </div>
                          </div>

                          <p class="ml-2">Minimum: ${{ features.bookings.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.bookings.price }}/booking
                          </p>

                          <p class="ml-2">
                            <el-input-number v-on:change="updatePricing(features.bookings)" :disabled="!features.bookings.enabled"
                                             size="small" v-model="features.bookings.quantity" :min="1"  />
                            <span class="ml-2"> bookings</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.bookings.total }}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Game management</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.game_management)"
                                         v-model="features.game_management.enabled"  />
                            </div>
                          </div>

                          <p class="ml-2">Minimum: ${{ features.game_management.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.game_management.price }}/game
                          </p>

                          <p class="ml-2">
                            <el-input-number v-on:change="updatePricing(features.game_management)" :disabled="!features.game_management.enabled"
                                             size="small" v-model="features.game_management.quantity" :min="1"  />
                            <span class="ml-2"> game</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.game_management.total }}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Photos</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.photos)"
                                         v-model="features.photos.enabled"  />
                            </div>
                          </div>

                          <p class="ml-2">Minimum: ${{ features.photos.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.photos.price }}/photo
                          </p>

                          <p class="ml-2">
                            <el-input-number v-on:change="updatePricing(features.photos)" :disabled="!features.photos.enabled"
                                             size="small" v-model="features.photos.quantity" :min="1"  />
                            <span class="ml-2"> photo</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.photos.total }}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Waivers</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.waivers)"
                                         v-model="features.waivers.enabled"  />
                            </div>
                          </div>
                          <p class="ml-2">Minimum: ${{ features.waivers.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.waivers.price }}/waiver <br>
                            <span style="font-size: x-small"> Free when bundled with Bookings, Photos, or Game Management</span>
                          </p>
                          <p class="ml-2">
                            <el-input-number :disabled="!features.waivers.enabled"
                                             v-on:change="calculateFreeTotal(features.waivers)" size="small" v-model="features.waivers.quantity" :min="1"  />
                            <span class="ml-2"> waivers</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.waivers.total }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Checklists</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.checklists)"
                                         v-model="features.checklists.enabled"  />
                            </div>
                          </div>

                          <p class="ml-2">Minimum: ${{ features.checklists.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.checklists.price }}/checklist
                          </p>

                          <p class="ml-2">
                            <el-input-number :disabled="!features.checklists.enabled"
                                             v-on:change="calculateFreeTotal(features.checklists)" size="small" v-model="features.checklists.quantity" :min="1"  />
                            <span class="ml-2"> checklists</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.checklists.total }}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div class="row">
                            <div class="col ml-2">
                              <h3 class="mb-1 ">Surveys</h3>
                            </div>
                            <div class="col text-right mr-2">
                              <el-switch active-color="#e14eca" v-on:change="updatePricing(features.surveys)"
                                         v-model="features.surveys.enabled"  />
                            </div>
                          </div>

                          <p class="ml-2">Minimum: ${{ features.surveys.minimum }}</p>
                          <p class="ml-2">Price:  ${{ features.surveys.price }}/survey
                          </p>

                          <p class="ml-2">
                            <el-input-number :disabled="!features.surveys.enabled"
                                             v-on:change="calculateFreeTotal(features.surveys)" size="small" v-model="features.surveys.quantity" :min="1"  />
                            <span class="ml-2"> surveys</span>
                          </p>
                          <p style="font-size: large" class="ml-2 mt-2">Total:  ${{ features.surveys.total }}</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col text-right">
                        <h3>Estimated monthly total: ${{ getTotalEstimate() }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {Switch, InputNumber} from "element-ui";
export default {
  name: "Pricing",
  components: {[Switch.name]: Switch, [InputNumber.name]: InputNumber},
  data() {
    return {
      features: {
        waivers: {
          enabled: false,
          price: 0.01,
          quantity: 1,
          minimum: 10,
          total: 0
        },
        bookings: {
          enabled: false,
          price: 0.165,
          quantity: 1,
          minimum: 30,
          total: 0
        },
        surveys: {
          enabled: false,
          price: 0.02,
          quantity: 1,
          minimum: 20,
          total: 0
        },
        game_management: {
          enabled: false,
          price: 0.06,
          quantity: 1,
          minimum: 20,
          total: 0
        },
        photos: {
          enabled: false,
          price: 0.06,
          quantity: 1,
          minimum: 20,
          total: 0
        },
        checklists: {
          enabled: false,
          price: 0.01,
          quantity: 1,
          minimum: 10,
          total: 0
        },
        resource_management: {
          enabled: false,
          price: 0,
          quantity: 1
        }
      },
    };
  },
  methods: {
    updatePricing(feature){
      console.log(feature)
      if(!feature.enabled){
        feature.quantity = 1
        feature.total = 0
      } else {
        if(feature.quantity * feature.price < feature.minimum){
          feature.total = parseFloat(feature.minimum).toFixed(2)
        } else {
          feature.total = (feature.quantity * feature.price).toFixed(2)
        }
      }
      this.calculateFreeTotal()
    },
    calculateFreeTotal(){
      //Waivers
      if(!this.features.bookings.enabled &&
        !this.features.game_management.enabled && !this.features.photos.enabled){
        if(this.features.waivers.enabled){
          if(this.features.waivers.quantity * this.features.waivers.price < this.features.waivers.minimum){
            this.features.waivers.total = parseFloat(this.features.waivers.minimum).toFixed(2)
          } else {
            this.features.waivers.total = (this.features.waivers.quantity * this.features.waivers.price).toFixed(2)
          }
        } else {
          this.features.waivers.total = 0
        }

        if(this.features.checklists.enabled){
          if(this.features.checklists.quantity * this.features.checklists.price < this.features.checklists.minimum){
            this.features.checklists.total = parseFloat(this.features.checklists.minimum).toFixed(2)
          } else {
            this.features.checklists.total = (this.features.checklists.quantity * this.features.checklists.price).toFixed(2)
          }
        } else {
          this.features.checklists.total = 0
        }

        if(this.features.surveys.enabled){
          if(this.features.surveys.quantity * this.features.surveys.price < this.features.surveys.minimum){
            this.features.surveys.total = parseFloat(this.features.surveys.minimum).toFixed(2)
          } else {
            this.features.surveys.total = (this.features.surveys.quantity * this.features.surveys.price).toFixed(2)
          }
        } else {
          this.features.surveys.total = 0
        }

      } else {
        this.features.waivers.total = 0
        this.features.checklists.total = 0
        this.features.surveys.total = 0
      }
      this.j++
    },
    getTotalEstimate(){
      return (parseFloat(this.features.waivers.total) + parseFloat(this.features.bookings.total)
        + parseFloat(this.features.checklists.total) +
        + parseFloat(this.features.surveys.total) +
        parseFloat(this.features.game_management.total)
        + parseFloat(this.features.photos.total)).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>
